import { OfferOptionsContext, OfferOptionsContextType } from "../context/OfferOptionsContext";
import { useProviderInitializedContext } from "hooks/useProviderInitializedContext";

export const useOfferOptions = (): OfferOptionsContextType => useProviderInitializedContext(OfferOptionsContext);
